var _line, _circle, _circle2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClockSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 50,
    viewBox: "0 0 80 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 74,
    y1: 25,
    x2: 37,
    y2: 25,
    stroke: "black",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 25,
    r: 4,
    transform: "rotate(90 76 25)",
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    transform: "rotate(90 25 25)",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_151_6564)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9976 12.5C31.9013 12.5 37.4976 18.0963 37.4976 25C37.4976 31.9037 31.9013 37.5 24.9976 37.5C18.0938 37.5 12.4976 31.9037 12.4976 25C12.4976 18.0963 18.0938 12.5 24.9976 12.5ZM24.9976 15C19.4751 15 14.9976 19.4775 14.9976 25C14.9976 30.5225 19.4751 35 24.9976 35C30.5201 35 34.9976 30.5225 34.9976 25C34.9976 19.4775 30.5201 15 24.9976 15ZM29.7888 19.1712C30.0851 18.9637 30.4876 18.9987 30.7426 19.255C30.9976 19.51 31.0301 19.9125 30.8213 20.205C28.0963 24.0125 26.5963 26.0525 26.3238 26.3263C25.5913 27.0575 24.4038 27.0575 23.6713 26.3263C22.9401 25.5938 22.9401 24.4062 23.6713 23.6737C24.1388 23.2075 26.1776 21.7063 29.7888 19.1712ZM31.8726 23.75C32.5626 23.75 33.1226 24.31 33.1226 25C33.1226 25.69 32.5626 26.25 31.8726 26.25C31.1826 26.25 30.6226 25.69 30.6226 25C30.6226 24.31 31.1826 23.75 31.8726 23.75ZM18.1226 23.75C18.8126 23.75 19.3726 24.31 19.3726 25C19.3726 25.69 18.8126 26.25 18.1226 26.25C17.4326 26.25 16.8726 25.69 16.8726 25C16.8726 24.31 17.4326 23.75 18.1226 23.75ZM21.0201 19.255C21.5076 19.7425 21.5076 20.5337 21.0201 21.0225C20.5326 21.51 19.7401 21.51 19.2526 21.0225C18.7651 20.535 18.7651 19.7425 19.2526 19.255C19.7401 18.7675 20.5313 18.7675 21.0201 19.255ZM24.9976 16.875C25.6876 16.875 26.2476 17.435 26.2476 18.125C26.2476 18.815 25.6876 19.375 24.9976 19.375C24.3076 19.375 23.7476 18.815 23.7476 18.125C23.7476 17.435 24.3076 16.875 24.9976 16.875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_151_6564"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockSmall);
export default __webpack_public_path__ + "static/media/clock-small.960d9f0828abc613ada5edba8c981c73.svg";
export { ForwardRef as ReactComponent };